import React from 'react';
import type { FormattedCurrencyProps } from './FormattedCurrency.types';
import { useFormattedCurrency } from './FormattedCurrency.hook';

export const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({
  value,
  symbolClassName = '',
  valueClassName = '',
  className = '',
  showPlus = false,
}) => {
  const { formatter, parts } = useFormattedCurrency(value);

  if (!symbolClassName && !valueClassName) {
    let formatted = formatter.format(value);
    if (showPlus && value > 0) {
      formatted = '+' + formatted;
    }
    return <span className={className}>{formatted}</span>;
  }

  let currencyPart = parts.find((p) => p.type === 'currency')?.value || '';
  const valuePart = parts
    .filter((p) => p.type !== 'currency')
    .map((p) => p.value)
    .join('')
    .trim();

  if (showPlus && value > 0) {
    // If showPlus is true, we want to prepend '+' to the symbol or value
    // Natively, the symbol comes first in most regions, so we prepend to symbolPart or wrap it.
    currencyPart = '+' + currencyPart;
  }

  return (
    <span className={className}>
      <span className={symbolClassName}>{currencyPart}</span>
      <span className={valueClassName}>{valuePart}</span>
    </span>
  );
};

export default FormattedCurrency;
